export const getMilestoneBinValue = (milestone, parentInitiative) => {
    if (milestone.status === 'Completed') return 'Unchanged';
    const historyEntries = parentInitiative?.history || [];
    const oneWeekAgo = new Date();
    oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
    oneWeekAgo.setHours(0, 0, 0, 0); // Normalize to start of day for comparison

    const prevWeekEntry = historyEntries.find(entry => {
        const changes = entry.changes || {}; // Ensure changes is an object to avoid errors
        return (
            new Date(entry.timestamp) >= oneWeekAgo && // Entry occurred on or after one week ago
            entry.action?.includes(`Milestone with Number ${milestone.milestoneNumber} has been updated.`) &&
            Object.prototype.hasOwnProperty.call(changes, 'endDate')
        );
    });
    const prevEndDate = prevWeekEntry?.changes?.endDate?.oldValue;
    const currentEndDate = milestone.endDate;
    if (!currentEndDate || !prevEndDate) {
        return '<not set>';
    }
    const currentMs = new Date(currentEndDate).getTime();
    const prevMs = new Date(prevEndDate).getTime();
    const daysDifference = Math.ceil((currentMs - prevMs) / (1000 * 3600 * 24));
    if (daysDifference < 0) return 'Accelerated';
    if (daysDifference === 0) return 'Unchanged';
    if (daysDifference >= 1 && daysDifference <= 7) return 'Delayed (1 to 7 days)';
    if (daysDifference >= 8 && daysDifference <= 14) return 'Delayed (8 to 14 days)';
    if (daysDifference >= 15 && daysDifference <= 30) return 'Delayed (15 to 30 days)';
    if (daysDifference > 30) return 'Delayed (more than 30 days)';

    return '<not set>'; // Fallback for any unhandled scenarios
};